export const formatMoney = (number: number | string | undefined | null) => {
  return (Number(number) ?? 0).toLocaleString('ru');
};
